import { OWebApp } from "oweb";
import { SXSector } from "@/gobl.bundle";
import ServiceStore from "./default";

export default class SectorsStore extends ServiceStore<SXSector> {
	private _busy = false;
	private _data_cb: any[] = [];

	constructor(app: OWebApp) {
		super(app, SXSector, "sectors");
	}

	loadSectors(then?: (success: boolean) => void, freeze: boolean = true) {

		then && this._data_cb.push(then);

		if (!this._busy) {
			this._busy = true;
			let m = this;

			this.getAll({}, function () {
				m.runCb(true);
				m._busy = false;

			}, function () {
				m.runCb(false);
				m._busy = false;
			}, freeze);
		} else {
			console.warn(`${ SectorsStore.name } busy!`);
		}
	}

	private runCb(success: boolean) {
		this._data_cb.forEach((fn) => fn(success));
		this._data_cb = [];
	}
}
